<template>
  <div class="maxh-2bar scroll-y">
    <v-toolbar class="card-bar">
      <v-toolbar-title>Motoristas</v-toolbar-title>

      <v-btn icon @click="$emit('reload')" class="ml-5">
        <v-icon>refresh</v-icon>
      </v-btn>

      <v-spacer />

      <v-text-field
        v-model="txtKeywords"
        label="Filtrar..."
        single-line
        hide-details
        class="pa-0"
      />

      <v-spacer />

      <v-switch v-model="showAll" label="Mostrar linhas inalteradas" hide-details />

      <v-spacer />

      <v-switch v-model="hideTechs" label="Ocultar técnicos" hide-details />

      <v-spacer />

      <v-btn icon @click="expandAll">
        <v-icon>mdi-expand-all</v-icon>
      </v-btn>
      <v-btn icon @click="collapseAll">
        <v-icon>mdi-collapse-all</v-icon>
      </v-btn>
    </v-toolbar>

    <v-expansion-panels accordion multiple focusable v-model="openedIndexes">
      <v-expansion-panel v-for="(row, i) in rows" :key="i" class="dense-panel">
        <v-expansion-panel-header
          :color="row.delta != 0 ? 'amber lighten-2' : null"
        >
          <div class="h-row">
            <div class="oderon-col-2">{{ row.clientId }}</div>
            <div class="oderon-col-2">{{ row.vehicleCode }}</div>
            <div class="oderon-col-1">
              {{ row.driverCountBefore }} D + {{ row.techCountBefore }} T
            </div>
            <div class="oderon-col-1">
              {{ row.driverCountAfter }} D + {{ row.techCountAfter }} T
            </div>
            <div class="oderon-col-1">delta: {{ row.delta }}</div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <DriverCompare :value="row" :showAll="showAll" :hideTechs="hideTechs"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
// import _ from 'lodash'
import {
  compareRows,
  isTech /*, compareRows, missingOne*/
} from './compare-utils.js'
// import { matchAnyLike } from 'oderon-commons/src/utils'

function isSameDriver(x, y) {
  return x.name == y.name && x.code == y.code
}

// function compareDrivers({ before, after, hideTechs }) {
//   let result = []
//   let allCids = _.uniq([
//     ..._.map(before, (x) => x.vehicle.clientId),
//     ..._.map(after, (x) => x.vehicle.clientId)
//   ]).sort()

//   for (let cid of allCids) {
//     let mbB = before.find((x) => x.vehicle.clientId == cid) || { drivers: [] }
//     let mbA = after.find((x) => x.vehicle.clientId == cid) || { drivers: [] }

//     let vehicleCode = mbB ? mbB.vehicle.code : mbA.vehicle.code

//     const bDrivers = mbB.drivers.filter(x => {
//       if ( hideTechs && isTech(x) ) return false
//       return true
//     })

//     const aDrivers = mbA.drivers.filter(x => {
//       if ( hideTechs && isTech(x) ) return false
//       return true
//     })

//     let pairs = compareRows(bDrivers, aDrivers, isSameDriver)

//     result.push({
//       clientId: cid,
//       vehicleCode,
//       mbB,
//       mbA,
//       pairs,
//       delta: pairs.filter(missingOne).length
//     })
//   }

//   return result
// }

export default {
  components: {
    DriverCompare: require('./DriverCompare.vue').default
  },
  props: {
    allClientIds: { type: Array, required: true },
    value: { required: true }
  },
  data() {
    // rows tem 1 objeto para cada clientId, com .after e .before
    const allRows = this.allClientIds.map((clientId) => {
      let vehicleCode =
        this.value.before &&
        this.value.before.vehicle &&
        this.value.before.vehicle.code
      if (vehicleCode == null)
        vehicleCode =
          this.value.after &&
          this.value.after.vehicle &&
          this.value.after.vehicle.code

      let before = this.value.before.find((x) => x.vehicle.clientId == clientId)
      if (before == null) before = { drivers: [] }

      let after = this.value.after.find((x) => x.vehicle.clientId == clientId)
      if (after == null) after = { drivers: [] }

      // Também já associa os motoristas after/before criando
      // linhas.
      const pairs = compareRows(before.drivers, after.drivers, isSameDriver)

      return {
        clientId,
        vehicleCode,
        before: before || { drivers: [] },
        after: after || { drivers: [] },
        pairs
      }
    })

    return {
      txtKeywords: null,
      showAll: false,
      hideTechs: false,
      openedIndexes: [],
      allRows
    }
  },
  computed: {
    rows() {
      // Para cada row, adiciona .driverCountBefore, .techCountBefore,
      // .driverCountAfter e .techCountAfter.
      return this.allRows.map((row) => {
        const techsBefore = row.before.drivers.filter((x) => isTech(x))
        const techCountBefore = techsBefore.length
        const driverCountBefore = row.before.drivers.length - techCountBefore

        const techsAfter = row.after.drivers.filter((x) => isTech(x))
        const techCountAfter = techsAfter.length
        const driverCountAfter = row.after.drivers.length - techCountAfter

        let delta =
          driverCountAfter +
          techCountAfter -
          (driverCountBefore + techCountBefore)
        if (this.hideTechs) delta = driverCountAfter - driverCountBefore

        return {
          ...row,
          driverCountBefore,
          techCountBefore,
          driverCountAfter,
          techCountAfter,
          delta
        }
      })
    }
    // filteredRows() {
    //   return this.rows.filter(r => {
    //     return matchAnyLike(
    //       this.txtKeywords,
    //       r.clientId,
    //       r.vehicleCode,
    //       r.itemB,
    //       r.itemA
    //     )
    //   })
    // }
  },
  methods: {
    expandAll() {
      let arr = this.rows.map((x, i) => i)
      this.openedIndexes = arr
    },

    collapseAll() {
      this.openedIndexes = []
    }
  }
}
</script>

<style lang="sass">
.dense-panel
  button
    padding: 8px 12px
    min-height: 32px
</style>
